import { ReactElement } from "react";
import { Link } from "react-router-dom";

export default function SuccessStoriesBanner(): ReactElement {
  return (
    <header className="success-stories-banner">
      <h1>
        <span>WSG Collabs</span>
      </h1>
      <nav aria-label="breadcrumb">
        <ol className="success-stories-breadcrumb">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li aria-hidden="true">&gt;</li>
          <li>
            <button type="button" className="success-stories-crumb">Resources</button>
          </li>
          <li aria-hidden="true">&gt;</li>
          <li aria-current="page">WSG Collaborations</li>
        </ol>
      </nav>
    </header>
  );
}
